module.exports = __webpack_public_path__ + "img/home_card_menue.cdb71b63.png";